<template>
  <div class="lad-flights-list">
    <LazyLoading
      :key="'flights'"
      class="lazy"
      :loading="items.length === 0"
      :loaded="lazy.flights"
      @loaded="(e) => (lazy.flights = e)"
    >
      <LadFlightAvaCard
        v-for="(ava, i) in items"
        :key="i"
        :item-key="i"
        :item="ava"
        :availability="ava"
        @scales="handleOpenScales"
      />
    </LazyLoading>
    <LadDialog :visible="modalScales.open" :handle-before-close="handleClose">
      <template slot="dialog-body">
        <div v-for="(flight, i) in modalScales.data" :key="i">
          <h2 v-if="i === 0"> {{ $t('flights.scales.back') }}</h2>
          <el-card>
            <div class="scales-list">
              <div class="left">
                <h3>{{ flight.cityFrom }}</h3>
                <h5 class="flight-time departure-time">
                  {{
                    $dayjs(flight.local_arrival).utc() | ladFnStrDate('HH:mm')
                  }}
                </h5>
                <p class="flight-date departure-date">
                  {{
                    $dayjs(flight.local_arrival).utc()
                      | ladFnStrDate('MMM DD, YYYY')
                  }}
                </p>
              </div>

              <div class="middle">
                <p>{{ flight.operating_flight_no }}</p>
                <el-divider>
                  <LadImage
                    :src="flight.airline.urlLogo"
                    :title="flight.airline.name"
                  />
                </el-divider>
                <!-- <p>{{ $dayjs(timeFlightGo).format('HH:mm') }}hrs</p> -->
              </div>

              <div class="right">
                <h3>{{ flight.cityTo }}</h3>
                <h5 class="flight-time arrival-time">{{
                  $dayjs(flight.local_arrival).utc() | ladFnStrDate('HH:mm')
                }}</h5>
                <p class="flight-date arrival-date">{{
                  $dayjs(flight.local_arrival).utc()
                    | ladFnStrDate('MMM DD, YYYY')
                }}</p>
              </div>
            </div>
          </el-card>
          <div
            v-if="
              i < modalScales.data.length - 1 &&
              flight.return !== modalScales.data[i + 1].return
            "
          >
            <el-divider>
              <span>{{
                $t('flights.nights_in_dest', {
                  num: items[modalScales.key].nightsInDest,
                })
              }}</span>
            </el-divider>
            <h2> {{ $t('flights.scales.back') }}</h2>
          </div>
        </div>
      </template>

      <template slot="dialog-footer">
        <el-button @click="handleClose"></el-button>
      </template>
    </LadDialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LadFlightAvaCard from './card'

export default {
  name: 'LadFlightAvaList',
  components: {
    LadDialog: () =>
      import(
        /* webpackChunkName: "lad-dialog" */ '@/components/frontends/Modal/index'
      ),
    LadFlightAvaCard,
  },
  data() {
    return {
      custom: { availability: [] },
      lazy: { flights: false },
      modalScales: { open: false, data: [], key: -1 },
    }
  },
  computed: {
    ...mapState('kiwi', {
      items: (state) => state.items,
    }),
  },
  methods: {
    handleOpenScales(key) {
      this.modalScales.open = true
      this.modalScales.data = this.items[key].route
      this.modalScales.key = key
    },
    handleClose() {
      this.modalScales.open = false
    },
  },
}
</script>

<style lang="scss">
.lad-flights-list {
  .lazy {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    grid-auto-rows: auto;
  }
  .el-dialog__body-wrapper {
    padding: 0;

    h2 {
      padding: 15px;
      margin: 0;
    }
  }

  .scales-list {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-gap: 10px;
    align-items: center;
    padding: 10px 15px 0;

    .middle {
      text-align: center;

      img {
        max-width: 24px;
      }
    }

    .right {
      text-align: right;
    }
  }

  @media screen and (max-width: 1200px) {
    .lazy {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 10px;
      grid-auto-rows: auto;
    }
  }

  @media screen and (max-width: 700px) {
    .lazy {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 10px;
      grid-auto-rows: auto;
    }

    .el-divider__text {
      padding: 0;
    }
  }
}
</style>
